<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">contents</h1>
<p class="nonindent"><a class="hlink" href="#/OEBPS/intro.htm">Introduction</a></p>
<p class="extract"><strong><a class="hlink" href="#/OEBPS/p01.htm#pt01">Beautiful Bags</a></strong></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c01.htm">Pretty Oriental Purse</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c02.htm">Oh So Versatile Handbag</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c03.htm">My Best Jumper Bag</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c04.htm">Girl About Town Carryall</a></p>
<p class="extract"><strong><a class="hlink" href="#/OEBPS/p02.htm#pt02">Gorgeous Gifts</a></strong></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c05.htm">All Wrapped Up</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c06.htm">Scent With Love</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c07.htm">Music To Go</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c08.htm">Fancy Stitching</a></p>
<p class="extract"><strong><a class="hlink" href="#/OEBPS/p03.htm#pt03">Perfect Pillows</a></strong></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c09.htm">Quilt-Effect Cushion</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c10.htm">Free As A Bird</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c11.htm">Vibrant Cushions</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c12.htm">Childhood Dreams</a></p>
<p class="extract"><a class="hlink" href="#/OEBPS/c13.htm#tec">Techniques</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c14.htm">Templates</a></p>
<p class="nonindent"><a class="hlink" href="#/OEBPS/c15.htm">Designer Credits</a></p>
<p class="center"><img alt="" src="OEBPS/images/5-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?38f0a591